export default {
  // db: "http://localhost:3000",
  db: "https://pep-scheduler.herokuapp.com",
};
